export default "__VITE_ASSET__9e5b9e4a__"